// A QR code drawn as inline SVG (uqr, no network, no canvas). Dark ink is a
// near-black, not true black, per the design law (INV-8).
import type { JSX } from 'preact';
import { renderSVG } from 'uqr';

/** The SVG markup for `text`, or null when it cannot be encoded. */
export function qrSvg(text: string): string | null {
  try {
    return renderSVG(text, { border: 2, blackColor: '#1a1a1a', whiteColor: '#ffffff' });
  } catch {
    return null;
  }
}

export function QrCode({ text, label = 'QR code' }: { text: string; label?: string }): JSX.Element {
  const svg = qrSvg(text);
  if (!svg) return <div class="qr-code qr-code--fault">This link is too long to draw as a code.</div>;
  return (
    <div
      class="qr-code"
      role="img"
      aria-label={label}
      data-testid="qr-code"
      style="width:200px;max-width:100%"
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  );
}
